import { render } from "./InputModal.vue?vue&type=template&id=35446c4a"
import script from "./InputModal.vue?vue&type=script&lang=js"
export * from "./InputModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rapid-rent/bissel-service-calls/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__